export default __webpack_public_path__ + "static/media/closew.84ef3f63.svg";